// Author SWL
// Date 2022-03-31 18:13:36

import * as model from "@/model/em/archive/EmArchToolChangeModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmArchToolChange(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ARCHIVE_URL,
        callbackApi: process.env.VUE_APP_EM_ARCHIVE_URL + '/emArchToolChange/workflow/complete-feedback',
        processDefinitionKey: "em_arch_tool_change",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
